import axios, { AxiosInstance } from "axios";
import { environment, requireHttpServiceUrl } from "../environment";

export class JobServiceApi {
  axios: AxiosInstance;

  constructor() {
    this.axios = axios.create({
      baseURL: requireHttpServiceUrl(
        environment.manticoreApiUrl,
        "REACT_APP_MANTICORE_API_URL",
      ),
      timeout: 10_000,
    });
  }
}
